module.exports = __webpack_public_path__ + "Roboto-Black.4c3b6229efe63a13dbb4.woff";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Black.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Black.woff
// module chunks = 5